import axios from 'axios';

axios.defaults.baseURL = '/sir/v1/';
